export default __webpack_public_path__ + "static/media/ballot.b562b9c9.svg";